import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CriticalOperationService {
  private readonly operations = new Set<symbol>();
  private readonly guards = new Map<symbol, () => boolean>();

  /** End must be called on completion, failure, cancellation, or owner teardown. */
  begin(label: string): () => void {
    const token = Symbol(label);
    this.operations.add(token);
    return () => this.operations.delete(token);
  }

  /** Evaluated at click time so dirty forms and component flags cannot go stale. */
  registerGuard(label: string, blocked: () => boolean): () => void {
    const token = Symbol(label);
    this.guards.set(token, blocked);
    return () => this.guards.delete(token);
  }

  get blocked(): boolean {
    if (this.operations.size) return true;
    for (const guard of this.guards.values()) {
      try { if (guard()) return true; } catch { return true; }
    }
    return false;
  }
}
